import {
	UPDATE_ALLERGEN_CATEGORY,
	SET_ALLERGEN_CATEGORY,
	RESET_ALLERGEN_CATEGORY
} from './allergenCategories.actions';

const defaultState = {
	ui: {},
	data: {
		defaultAllergenCategory: {}
	}
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
	case SET_ALLERGEN_CATEGORY: {
		return {
			...state,
			data: {
				...state.data,
				defaultAllergenCategory: payload
			}
		};
	}

	case UPDATE_ALLERGEN_CATEGORY: {
		return {
			...state,
			data: {
				...state.data,
				defaultAllergenCategory: {
					...state.data.defaultAllergenCategory,
					...payload
				}
			}
		};
	}

	case RESET_ALLERGEN_CATEGORY: {
		return {
			...state,
			data: {
				...state.data,
				defaultAllergenCategory: {}
			}
		};
	}

	default:
		return state;
	}
}

export default reducer;
